// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__28oNA","col":"styles_col__3D6tV"};